export const ANALYTICS_TRACK = 'ANALYTICS_TRACK';

export const track = ({ event, properties }) => ({
  type: ANALYTICS_TRACK,
  payload: {
    event,
    properties
  }
});



// WEBPACK FOOTER //
// ./js/actions/analytics.js